import { render, staticRenderFns } from "./message-abstract-file.vue?vue&type=template&id=f976e31e&scoped=true"
import script from "./message-abstract-file.vue?vue&type=script&setup=true&lang=ts"
export * from "./message-abstract-file.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./message-abstract-file.vue?vue&type=style&index=0&id=f976e31e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f976e31e",
  null
  
)

export default component.exports